var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{directives:[{name:"stick-to-left",rawName:"v-stick-to-left",value:(_vm.stickyScrolling),expression:"stickyScrolling"}],staticClass:"table-cell"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }